import { Dialog } from 'ui';

import { Camera, type CameraProps } from '../Camera/Camera';

export const CameraDialog = ({
  isCameraOpen,
  toggle,
  cameraProps,
}: {
  isCameraOpen: boolean;
  toggle: () => void;
  cameraProps: CameraProps;
}) => {
  return (
    <Dialog fullScreen open={isCameraOpen}>
      <Camera {...cameraProps} handleClose={cameraProps.handleClose ?? toggle} />
    </Dialog>
  );
};
